import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { AuthService } from 'src/app/services/auth.service';
import { ModalService } from 'src/app/services/modal.service';
import { OfflineStorageService } from 'src/app/services/offline-storage.service';
import { SharedService } from 'src/app/services/shared.service';
import { getPaymentList } from 'src/app/store/actions/payment.action';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit, AfterViewInit {
  userProfile: any;

  ngUnsubscribe = new Subject<void>();

  schoolOpen: Boolean = false;
  schoolAbout: Boolean = false;
  schoolCalendar: Boolean = false;
  schoolFacilities: Boolean = false;
  curriculumOpen: Boolean = false;
  financeOpen: Boolean = false;
  SchemesOpen: Boolean = false;
  adminOpen: Boolean = false;
  registrarOpen: Boolean = false;
  professorOpen: Boolean = false;
  studentOpen: Boolean = false;

  activeStepIndex = 0;

  applicationCompleted = false;
  preEnrollmentCompleted = false;
  firstInterviewCompleted = false;
  academicReqCompleted = false;
  secondInterviewCompleted = false;
  LOACompleted = false;
  enrollmentCompleted = false;

  @ViewChild('sidenav') sidenav!: MatSidenav;

  constructor(
    private store: Store<AppState>,
    private sharedService: SharedService,
    public router: Router,
    private authService: AuthService,
    private offlineStorageService: OfflineStorageService,
    private cdr: ChangeDetectorRef,
    private accountService: AccountService,
    private observer: BreakpointObserver,
    private modalService: ModalService
  ) { }

  async ngOnInit() {
    this.sharedService.sidenavToggle$.subscribe(() => {
      this.sidenav.toggle();
    });

    const user = await this.offlineStorageService.getObject('user');
    this.userProfile = JSON.parse(user);
  }

  ngAfterViewInit() {
    this.observer.observe(['(max-width: 768px)']).subscribe(result => {
      if (result.matches) {
        this.sidenav.mode = 'over';
        this.sidenav.close();
        this.cdr.detectChanges();
      } else {
        this.sidenav.mode = 'side';
        this.sidenav.open();
        this.cdr.detectChanges();
      }
    });
  }

  logout(){
    this.store.dispatch(setLoadingSpinner({status: true}))
    this.authService.autoLogout();
  }

  getImg(name){
    return `assets/img/sidenav/${name}.svg`
  }

  changeStep(step: number) {
    this.activeStepIndex = step;
  }

  openAssessmentFilter(){
    this.modalService.showStudentFilter('assessment');
  }

  openSchedulingFilter(){
    this.modalService.showStudentFilter('scheduling');
  }

  goToPaymentList(){
    const filter = {
      // student_id: '02-509-01-7302'
    }
    this.store.dispatch(setLoadingSpinner({status: true}));
    this.store.dispatch(getPaymentList({data: filter}))
  }

  checkAccess(allowedAccessTypes: number[]): boolean {
    if (!this.userProfile || !this.userProfile.employee || !this.userProfile.employee.employee_type) {
      return false;
    }
    const accessType = this.userProfile.employee.employee_type.access_type;
    return allowedAccessTypes.includes(accessType);
  }
}
